import lodashPick from 'lodash/fp/pick';

export const autocompleteFieldgroup = [
  'googlePlaceId',
  'streetName',
  'streetNumber',
  'streetSuffix',
  'county',
  'zip',
  'city',
  'stateCode',
  'latitude',
  'longitude',
];
export const pickAutocompleteFields = lodashPick(autocompleteFieldgroup);

export const requiredAddressFields = ['streetName', 'streetNumber', 'zip', 'city', 'stateCode'];
export const pickRequiredAddressFields = lodashPick(requiredAddressFields);
